<template>
  <div class="difficulty-page">
    <hint-page v-if="showHint" @close="showHint = false">
      <i>SELECT YOUR DIFFICULTY LEVEL.</i>
    </hint-page>
    <hint-page v-show="showSelectedTask" @close="showSelectedTask = false">
      <i>your selected task is&nbsp;</i>
      <b>{{ task }}</b>
    </hint-page>

    <h1 class="heading">
      <b>[&nbsp;</b>
      <i>Select difficulty</i>
      <b>&nbsp;]</b>
    </h1>

    <ul class="options">
      <li :class="easyClass" @click="$store.dispatch('setDifficulty', 'easy')">
        <span class="list-title">> Novice</span>
        <span class="list-text">8 clues</span>
      </li>
      <li
        :class="mediumClass"
        @click="$store.dispatch('setDifficulty', 'medium')"
      >
        <span class="list-title">> Experienced</span>
        <span class="list-text">5 clues</span>
      </li>
      <li :class="hardClass" @click="$store.dispatch('setDifficulty', 'hard')">
        <span class="list-title">> Master</span>
        <span class="list-text">2 clues</span>
      </li>
    </ul>

    <page-subnav>
      <page-subnav-item
        @click="showSelectedTask = true"
        :active="showSelectedTask"
        >task</page-subnav-item
      >
    </page-subnav>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HintPage from "./HintPage.vue";
import PageSubnav from "../components/PageSubnav";
import PageSubnavItem from "../components/PageSubnavItem";

export default {
  name: "difficulty-page",
  components: { HintPage, PageSubnav, PageSubnavItem },
  data: function () {
    return { showHint: true, showSelectedTask: false };
  },
  computed: {
    ...mapState(["difficulty"]),
    ...mapGetters(["task"]),
    easyClass() {
      if (!this.difficulty) {
        return "";
      } else if (this.difficulty === "easy") {
        return "active";
      } else {
        return "inactive";
      }
    },
    mediumClass() {
      if (!this.difficulty) {
        return "";
      } else if (this.difficulty === "medium") {
        return "active";
      } else {
        return "inactive";
      }
    },
    hardClass() {
      if (!this.difficulty) {
        return "";
      } else if (this.difficulty === "hard") {
        return "active";
      } else {
        return "inactive";
      }
    },
  },
};
</script>

<style lang="less">
.difficulty-page {
  width: 768px;
  height: 768px;
  padding: 120px;
  position: relative;
  background-image: url("~@/assets/images/page-blank.png");

   .heading {
    margin-bottom: 1em;
  }

  .options {
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      font-size: 30px;
      font-weight: 100;

      &.inactive {
        opacity: 0.25;
      }

      .list-index {
        display: inline-block;
        font-style: italic;
        width: 80px;

        &::before {
          content: "[ ";
          font-weight: bold;
          font-style: normal;
        }
        &::after {
          content: " ]";
          font-weight: bold;
          font-style: normal;
        }
      }

      .list-title {
        font-style: italic;
        font-weight: bold;
        &::after {
          content: ", ";
        }
      }

      .list-text {
        font-style: italic;
      }
    }
  }

  .page-subnav {
    position: absolute;
    bottom: 30px;
    right: 90px;

    a {
      font-style: italic;
      opacity: 0.25;
      cursor: pointer;
    }
  }
}

.difficulty-page .options li {
  cursor: not-allowed;
}
.controller .difficulty-page .options li {
  cursor: pointer;
}
</style>
